export enum CondOperator {
  NULL = "NULL",
  NOT_NULL = "NOT_NULL",
  EQUAL = "EQUAL",
  NOT_EQUAL = "NOT_EQUAL",
  GT = "GT",
  GT_EQUAL = "GT_EQUAL",
  LT = "LT",
  LT_EQUAL = "LT_EQUAL",
  IN = "IN",
  NOT_IN = "NOT_IN",
  BETWEEN = "BETWEEN",
  LIKE = "LIKE",
  LEFT_LIKE = "LEFT_LIKE",
  RIGHT_LIKE = "RIGHT_LIKE",
  NOT_LIKE = "NOT_LIKE",
  BELONG_TO = "BELONG_TO"
}
